module.exports = __webpack_public_path__ + "img/5400.a423a4c4.jpg";